import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { VoucherApi } from 'common/api/resources/Voucher';
import { Member } from 'common/api/models/Member';
import { FormInput } from '../form/FormInput';

export interface DropDownDialog {}
interface DropDownDialogProps {
  title?: string;
  isOpen: boolean;
  voucher: string;
  member?: Member;
  onSave: () => void;
  onCancel: () => void;
  drawingStatus?: string;
  communicationSentDate?: string;
  examSubmittedDate?: string;
  examPassedDate?: string;
  examFailiedDate?: string;
}
class FormValues {
  drawingStatus: string;
}

export class DropDownDialog extends React.Component<DropDownDialogProps> {
  initialValues() {
    return {
      drawingStatus: this.props.drawingStatus,
    };
  }

  handleSubmit = async (values: FormValues) => {
    await this.setState({ isLoading: true });
    if (this.props.voucher) {
      let updateParams = {};
      updateParams = {
        drawingStatus: values.drawingStatus,
      };
      let nowDate = new Date();
      let nowDateIso = nowDate.toISOString();
      if (values.drawingStatus === 'COMMUNICATION_SENT') {
        updateParams = {
          drawingStatus: values.drawingStatus,
          drawingStatusCommunicationSentDate: nowDateIso,
        };
      }
      if (values.drawingStatus === 'DRAWING_EXAM_WINDOW_REQUESTED') {
        updateParams = {
          drawingStatus: values.drawingStatus,
          drawingStatusExamWindowRequestedDate: nowDateIso,
        };
      }
      if (values.drawingStatus === 'DRAWING_EXAM_SUBMITTED') {
        updateParams = {
          drawingStatus: values.drawingStatus,
          drawingStatusExamSubmittedDate: nowDateIso,
        };
      }
      if (values.drawingStatus === 'DRAWING_EXAM_PASSED') {
        updateParams = {
          drawingStatus: values.drawingStatus,
          drawingStatusExamPassedDate: nowDateIso,
        };
      }

      if (values.drawingStatus === 'DRAWING_EXAM_FAILED') {
        updateParams = {
          drawingStatus: values.drawingStatus,
          drawingStatusExamFailedDate: nowDateIso,
        };
      }

      VoucherApi.updateVoucher(this.props.voucher, updateParams)
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onSave();
        })
        .catch(e => {
          this.setState({ isLoading: false });
        });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<FormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                <FormInput
                  id="drawingStatus"
                  name="drawingStatus"
                  label="Drawing Status"
                  tag="select"
                  autoComplete="off"
                >
                  <option value="NOT_STARTED">NOT STARTED</option>
                  <option value="COMMUNICATION_SENT">COMMUNICATION SENT</option>
                  <option value="DRAWING_EXAM_WINDOW_REQUESTED">DRAWING EXAM WINDOW REQUESTED</option>
                  <option value="DRAWING_EXAM_SUBMITTED">DRAWING EXAM SUBMITTED</option>
                  <option value="DRAWING_EXAM_PASSED">DRAWING EXAM PASSED</option>
                  <option value="DRAWING_EXAM_FAILED">DRAWING EXAM FAILED</option>
                </FormInput>
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/DropDownDialog.tsx